import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  ITableAction,
  TableControlComponent,
  TableControlModule
} from "frontier";
import ControlGuids from "../../../api/ControlGuids";

@Component({
  selector: 'app-cart-import-table',
  standalone: true,
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  imports: [TableControlModule],
  providers: [
    {provide: TableControlComponent, useExisting: CartImportTableComponent},
  ],
})
export class CartImportTableComponent extends TableControlComponent{
  override GUID: string = ControlGuids.TCartTable;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
  ]);
}
